<template>
  <b-card>
    <b-row>
      <b-col cols="3">
        <b-form-group>
          <b-form-text>Titel</b-form-text>
          <b-input-group>
            <b-form-input v-model="onderdeel.title" />
            <b-input-group-append>
              <b-input-group-text>
                <b-check v-model="onderdeel.isElement">
                  is element
                </b-check>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <import-onderdeel-koppeling
          v-if="!onderdeel.isElement"
          v-model="onderdeel.import"
        />
        <b-form-group>
          <b-form-text>Inspectie opmerking</b-form-text>
          <b-form-textarea v-model="onderdeel.notitie" />
        </b-form-group>
        <b-form-group>
          <b-form-text>Startjaar onderdeel</b-form-text>
          <b-form-input
            v-model.number="onderdeel.jaar"
            :placeholder="(onderdeel.jaar || onderdeel.basejaar).toString()"
            debounce="500"
          />
        </b-form-group>
        <b-form-group>
          <b-form-text>Multiplier</b-form-text>
          <b-input-group>
            <b-form-input
              v-model="onderdeel.multiplier"
              placeholder="Dynamische expressie"
            />
            <b-input-group-append>
              <b-dropdown :key="onderdeel.title">
                <template #button-content>
                  <i class="fa fa-plus" /> presets
                </template>
                <b-dropdown-item
                  v-for="(item, index) in presets"
                  :key="'preset-' + index"
                  @click="setMultiplier(item.value)"
                >
                  {{ item.label }}
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group >
          <b-form-text>Max conditie</b-form-text>
          <conditie-limit
            v-model="onderdeel.maxConditie"
            label="Max conditie uitzondering"
            :show-global-option="true"
            :show-info="true"
            scope="onderdeel"
            container-class="mb-3"
          />
        </b-form-group>
        <b-form-group>
          <b-form-text>Foto</b-form-text>
          <b-card-img 
            v-if="onderdeel.foto" 
            :src="onderdeel.foto.secure_url"
          />
          <b-button 
            @click="$emit('foto-selecteren-voor', onderdeel)"
          >
            <i class="fa fa-photo mr-2" />Kies foto
          </b-button>
          <b-button 
            variant="danger" 
            @click="onderdeel.foto = null"
          >
            <i class="fa fa-times" /> Verwijder
          </b-button>
        </b-form-group>
      </b-col>
      <b-col>
        <b-tabs small>
          <b-tab v-if="onderdeel.isElement && onderdeel.isElement == true">
            <template #title>
              <i class="fa fa-cubes" /> Element
            </template>
            <b-row>
              <b-col sm="8">
                <b-select
                  v-if="onderdeel.elementId == null"
                  v-model="onderdeel.elementId"
                >
                  <template #first>
                    <option disabled>
                      -- Kies een element --
                    </option>
                  </template>
                  <b-select-option
                    v-for="(index, key) in elementen"
                    :key="key"
                    :value="key"
                  >
                    {{ elementen[key].Naam }}
                  </b-select-option>
                </b-select>

                <element-card
                  v-else
                  :title="elementen[onderdeel.elementId].Naam"
                  :form="elementen[onderdeel.elementId].Form"
                  :data="inventarisatie"
                >
                  <b-button
                    size="sm"
                    variant="ghost"
                    @click="onderdeel.elementId = null"
                  >
                    <i class="fa fa-close" />
                  </b-button>
                </element-card>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab 
            v-if="!onderdeel.isElement" 
            :active="!onderdeel.isElement"
          >
            <template #title>
              <div v-if="onderdeel.acties && onderdeel.acties.length == 0">
                Geen herhalingen
              </div>
              <div v-else>
                <i class="fa fa-refresh" />
                {{ onderdeel.acties.length }}
                {{ onderdeel.acties.length == 1 ? "herhaling" : "herhalingen" }}
              </div>
            </template>
            <herhalingen-details
              :onderdeel="onderdeel"
              :jaar="onderdeel.jaar || onderdeel.basejaar"
              :presets="presets"
              :fotos="fotos"
            />
          </b-tab>
          <b-tab v-if="!onderdeel.isElement">
            <template #title>
              <div v-if="onderdeel.gebreken.length == 0">
                Geen gebreken
              </div>
              <div v-else>
                <i class="fa fa-exclamation-triangle" />
                {{ onderdeel.gebreken.length }}
                {{ onderdeel.gebreken.length == 1 ? "gebrek" : "gebreken" }}
              </div>
            </template>
            <gebreken-details :onderdeel="onderdeel" />
          </b-tab>
          <b-tab title="Checklist">
            <b-button
              v-if="!onderdeel.checklist"
              @click="
                $set(onderdeel, 'checklist', { toelichting: '', opties: [] })
              "
            >
              Toevoegen aan checklist
            </b-button>

            <b-form-group
              v-if="onderdeel.checklist"
              label="Toelichting controle"
            >
              <b-textarea
                v-model="onderdeel.checklist.toelichting"
                placeholder="Omschrijving van de controle"
              />
            </b-form-group>

            <b-checkbox-group
              v-if="onderdeel.checklist"
              v-model="onderdeel.checklist.opties"
              :options="[
                { value: 'A', text: 'Startjaar uitrekenen' },
                { value: 'B', text: 'Import martrix' },
                { value: 'D', text: 'Uitvoering toevoegen' },
                { value: 'E', text: 'Waarschuwing tekst' },
              ]"
              stacked
            />

            <b-button
              v-if="onderdeel.checklist"
              class="my-3"
              variant="danger"
              @click="$set(onderdeel, 'checklist', null)"
            >
              <i class="fa fa-trash" /> Verwijderen uit checklist
            </b-button>
          </b-tab>

          <b-tab 
            v-if="!onderdeel.isElement" 
            title="Uitkomsten"
          >
            <uitkomsten-details 
              :onderdeel="onderdeel" 
              :mods="mods"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import ElementCard from "@/components/ElementCard";
import GebrekenDetails from "@/views/prognoses/onderdeel/Gebreken";
import HerhalingenDetails from "@/views/prognoses/onderdeel/Herhalingen";
import UitkomstenDetails from "@/views/prognoses/onderdeel/Uitkomsten";
import ImportOnderdeelKoppeling from "@/components/ImportOnderdeelKoppeling";
import ConditieLimit from "@/components/ConditieLimit";

export default {
  name: "OnderdeelCard",
  components: {
    ConditieLimit,
    GebrekenDetails,
    HerhalingenDetails,
    UitkomstenDetails,
    ElementCard,
    ImportOnderdeelKoppeling
  },
  filters: {
    pretty: function (value) {
      return JSON.stringify(value, null, 2);
    },
  },
  props: {
    onderdeel: { type: Object },
    config: { type: Object },
    fotos: { type: Array },
    multiplier: { type: Number },
    mods: { type: Array },
    elementen: {
      type: Object,
      default: function () {
        return {};
      },
    },
    inventarisatie: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      presets: [
        { label: "Cabinetoegangen", value: "1 * e.ATC" },
        { label: "Schachttoegangen", value: "1 * e.ASCH" },
      ],
    };
  },
  computed: {
    items: {
      get: function () {
        if (this.onderdeel.acties == null)
          this.$set(this.onderdeel, "acties", []);

        return this.onderdeel.acties.concat(this.onderdeel.gebreken);
      },
    },
    total: function () {
      var total = 0;
      this.items.forEach((i) => (total += Number(i.bedrag)));
      return total;
    },
  },
  methods: {
    addRevisieJaar(jaar) {
      if (!this.onderdeel.jaren) this.$set(this.onderdeel, "jaren", []);
      jaar.bedrag = this.onderdeel.revisie;
      this.onderdeel.jaren.push(jaar);
    },
    setMultiplier(value) {
      if (this.onderdeel.multiplier == null) {
        this.$set(this.onderdeel, "multiplier", value);
      } else {
        this.onderdeel.multiplier = value;
      }
    },
  },
};
</script>
